export default __webpack_public_path__ + "b95ca7956f12b2df05089e469ac47eb6.svg";